/**
 * Utility functions for address handling
 */

/**
 * Remove "powered by Google" text from address strings
 * @param {string} address - The address string that may contain "powered by Google"
 * @returns {string} - Cleaned address without "powered by Google" text
 */
export const cleanAddress = (address) => {
  if (!address) return '';
  
  // Remove "powered by Google" text (case insensitive, with various spacing and punctuation)
  let cleaned = address
    .replace(/\s*powered\s+by\s+google\s*/gi, '')
    .replace(/\s*Powered\s+by\s+Google\s*/g, '')
    .replace(/\s*POWERED\s+BY\s+GOOGLE\s*/g, '')
    .replace(/powered\s*by\s*google/gi, '')
    .replace(/Powered\s*by\s*Google/g, '')
    .replace(/POWERED\s*BY\s*GOOGLE/g, '')
    .replace(/\s*\[powered\s+by\s+google\]\s*/gi, '')
    .replace(/\s*\(powered\s+by\s+google\)\s*/gi, '')
    .replace(/\s*-\s*powered\s+by\s+google\s*/gi, '')
    .replace(/\s*,\s*powered\s+by\s+google\s*/gi, '')
    .trim();
  
  // Remove any trailing/leading whitespace and clean up multiple spaces
  cleaned = cleaned.replace(/\s+/g, ' ').trim();
  
  // Remove any remaining "powered by" references
  cleaned = cleaned.replace(/\s*powered\s+by\s*/gi, '').trim();
  
  return cleaned;
};

/**
 * Clean address object (for trip origin/destination)
 * @param {object} addressObj - Address object with address property
 * @returns {object} - Address object with cleaned address
 */
export const cleanAddressObject = (addressObj) => {
  if (!addressObj) return addressObj;
  
  if (addressObj.address) {
    return {
      ...addressObj,
      address: cleanAddress(addressObj.address)
    };
  }
  
  return addressObj;
};

